<template>
  <div class="product-center">
    <section class="page-header">
      <div class="container">
        <h1>产品中心</h1>
        <p>Products Center</p>
      </div>
    </section>

    <section class="products-section">
      <div class="container">
        <div class="products-grid">
          <div class="product-card">
            <div class="product-video">
              <iframe 
                :src="products[0].videoUrl" 
                frameborder="0" 
                allowfullscreen
                class="video-iframe">
              </iframe>
            </div>
            <div class="product-info">
              <h3><router-link :to="'/product/' + products[0].id" class="product-name-link">{{ products[0].name }}</router-link></h3>
              <!-- <p class="product-description">{{ products[0].description }}</p>
              <p class="product-category">{{ products[0].category }}</p> -->
              <router-link :to="'/product/' + products[0].id" class="view-details">查看详情</router-link>
            </div>
          </div>
          
          <!-- 保留空的占位符以维持一行3个产品的样式布局 -->
          <div class="product-card placeholder"></div>
          <div class="product-card placeholder"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ProductCenter',
  data() {
    return {
      products: [
        {
          id: 1,
          name: '挤压丝锥加工',
          videoUrl: 'https://v.qq.com/txp/iframe/player.html?vid=f3307pe9uuq'
        }
      ]
    }
  },
  methods: {
    
  }
}
</script>

<style scoped>
.product-center {
  margin-top: 80px;
}

.page-header {
  background: linear-gradient(to right,#0a338c,#0a338c);
  color: white;
  padding: 60px 0;
  text-align: center;
}

.page-header h1 {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.products-section {
  padding: 80px 0;
  background-color: #f8f9fa;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
}

.product-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow: hidden;
  transition: transform 0.3s;
}

.product-card:hover {
  transform: translateY(-10px);
}

.product-card.placeholder {
  visibility: hidden;
  background: transparent;
  box-shadow: none;
}

.product-video {
  height: 250px;
  overflow: hidden;
}

.video-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.product-info {
  padding: 25px;
}

.product-info h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #333;
}

.product-name-link {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.product-name-link:hover {
  color: #409eff;
}

.product-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  min-height: 60px;
}

.product-category {
  color: #409eff;
  font-weight: 500;
  margin-bottom: 20px;
}

.view-details {
  display: inline-block;
  padding: 10px 20px;
  background-color:rgb(247, 25, 25);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.view-details:hover {
  background-color: #66b1ff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .product-center {
    margin-top: 140px;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .page-header p {
    font-size: 1rem;
  }
  
  .products-section {
    padding: 50px 0;
  }
  
  .products-grid {
    grid-template-columns: 1fr;
  }
  
  .product-video {
    height: 200px;
  }
  
  .product-card.placeholder {
    display: none;
  }
}


</style>